import React from "react";
import Toast from "react-bootstrap/Toast";
import ToastHeader from "react-bootstrap/ToastHeader";

function ToastNotification(props) {
  return (
    <div
      className="toast-notification"
      style={{
        position: "fixed",
        top: 15,
      }}
    >
      <Toast
        show={props.show}
        onClose={props.clickClose}
        delay={6000}
        autohide={props.autoHide ? props.autoHide : false}
      >
        <ToastHeader closeButton={false}>
          <div>
            {props.message
              ? props.message
              : "Unexpected error, please contact administrator."}
            <span className="toast-close" onClick={props.clickClose}>
              Dismiss
            </span>
          </div>
        </ToastHeader>
      </Toast>
    </div>
  );
}

export default ToastNotification;
